export default __webpack_public_path__ + "static/media/Portfolio.a9a7d7eb.png";